module.exports = __webpack_public_path__ + "img/fourColor.3151fc85.png";